import React from 'react';
import { useSearchParams } from 'react-router-dom';
import BlogCard from './BlogCard';
import { useBlogPosts } from '../../hooks/useBlogPosts';

export default function BlogList() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category') || 'All';
  const search = searchParams.get('search') || '';
  
  const { posts, loading, error } = useBlogPosts(category, search);

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 animate-pulse">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="bg-gray-100 rounded-lg h-96" />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-red-600 mb-4">{error}</p>
        <button 
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Try Again
        </button>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="text-center py-8 text-gray-600">
        No blog posts found {category !== 'All' && `in category "${category}"`}
        {search && ` matching "${search}"`}.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {posts.map((post) => (
        <BlogCard key={post.slug} post={post} />
      ))}
    </div>
  );
}